/**
 * TODO: 美团酒店
 * 排序
 * 入离时间
 * 位置
 * 筛选
 *
 */
// remove array;
//
function removeArrItem({ category = [], sign }) {
  const names = Array.isArray(sign) ? sign : [sign];
  const resultMap = new Map();
  names.forEach((itemName) => {
    category.some((item, i) => {
      if (item.name === itemName) {
        category.splice(i, 1);
        resultMap.set(item.name, item);
      }
    });
  });

  return resultMap;
}
// 排序
const SortList = [
  {
    id: 1,
    name: "综合推荐",
    shotName: "综合",
  },
  {
    id: 7,
    name: "距离 近到远",
    shotName: "距离",
  },
  {
    id: 6,
    name: "好评优先",
    shotName: "好评",
  },
  {
    id: 12,
    sortType: 2, // 价格最低正序
    name: "低价优先",
    shotName: "低价",
  },
  {
    id: 4000,
    sortType: 1, // 高倒序
    name: "高价优先",
    shotName: "高价",
  },
];

const FilterList = [
  {
    name: "价格",
    type: "input",
  },
  {
    name: "星级",
    type: "checkout",
    list: ["豪华/五星", "高档/四星", "舒适/三星", "经济型"],
  },
  {
    name: "床型",
    type: "checkout",
    list: [
      "单人床",
      "大床",
      "圆床",
      "圆形水床",
      "方形水床",
      "小型双人床",
      "双人床",
      "特大床",
      "上下铺",
    ],
  },
  // {
  //   name: "酒店类型",
  //   type: "checkout",
  //   list: ["经济型酒店", "别墅", "温泉酒店"]
  // }
];

const hotelFilter = (category) => {
  const sign = ["区域", "品牌", "商圈", "酒店类型", "行政区"];
  const filerValues = removeArrItem({ category, sign });
  const RegionData = filerValues.get("行政区") || {},
    BannerData = filerValues.get("品牌") || {},
    BusinessData = filerValues.get("商圈") || {},
    HotelTypes = filerValues.get("酒店类型") || {};
  const fields = [
    // 排序
    {
      name: "排序",
      list: SortList,
    },
    // 入离日期
    {
      name: "入离日期",
      component: "dateRange",
      list: [
        {
          id: "checkDate",
          name: "入住日期",
          shotName: "入住",
        },
        {
          id: "departureDate",
          name: "离店日期",
          shotName: "离店",
        },
      ],
      multiSelect: false,
    },
    // 位置
    {
      name: "位置",
      component: "radioChoice",
      list: [
        {
          name: "行政区", // TODO：行政区
          list: RegionData.list || [],
        },
        {
          name: "商圈",
          list: BusinessData.list || [],
        },
      ],
    },
    // 筛选
    {
      name: "筛选",
      component: "multiChoice",
      list: [
        ...FilterList,
        {
          name: "酒店类型",
          type: "checkout",
          list: HotelTypes.list || [],
        },
        {
          name: "品牌",
          type: "checkout",
          list: BannerData.list || [],
        },
      ],
    },
  ];
  fields.forEach((field) => category.push(field));

  return category;
};

export { hotelFilter };
